// Auth
export const  REGISTER_INSTRUCTORS = 'Auth/register-instructor'
export const  REGISTER_STUDENTS = 'Auth/register-student'
export const  LOGIN = 'Auth/login'
export const FORGET_PWD = 'Auth/forgot-password'
export const CHANGE_PWD = 'Auth/change-password'
export const RESEND_EMAIL = 'Auth/resend-email-confirmation'
export const REFRESH_TOKEN = 'Auth/refresh-token'
export const  REVOKE_TOKEN = 'Auth/revoke-token'

// Instructors
export const INSTRUCTOR_INFO = 'Instructors'
export const INSTRUCTOR_COURSES ='Course/instructor'

// Students
export const STUDENT_INFO = 'Students'

// Courses
export const GET_COURSES = 'Course/search'
export const SEARCH_COURSES = 'Search/courses'
export const COURSES_BY_ID = 'Course/category'

// Categories
export const GET_CATEGORIES = 'Category'